__turbopack_context__.v({
  "buttonGroupContainer": "panelButton-module-scss-module__Ewz7CG__buttonGroupContainer",
  "panelButton": "panelButton-module-scss-module__Ewz7CG__panelButton",
  "panelButtonContainer": "panelButton-module-scss-module__Ewz7CG__panelButtonContainer",
  "panelControl": "panelButton-module-scss-module__Ewz7CG__panelControl",
});
